module.exports = __webpack_public_path__ + "img/famous.377fad90.jpg";